export default __webpack_public_path__ + "static/media/18.67e7b03d.pdf";